jQuery(document).ready(function($) {

/* announcements bar */
$(document).ready(function () {
	if (typeof Swiper === 'undefined') return false;
	if (!$('.highlights-slider').length) return false;

	const getTotalWidth = function (swiper) {
		let width = 0;
		swiper.$el[0]
			.querySelectorAll('.swiper-slide')
			.forEach(function (element) {
				width += element.offsetWidth;
			});
		return width;
	};

	const getAdjustedSpeed = function (swiper) {
		const speed = 15000; // Higher is faster
		const slide =
			swiper.$el[0].querySelectorAll('.swiper-slide')[
				swiper.activeIndex
			];
		const standardWidth = 150;
		const slideWidth = slide.offsetWidth;
		const slideMargin = parseInt(getComputedStyle(slide).marginRight);
		const timePerPixel = (standardWidth + slideMargin) / speed;
		const adjustedSpeed = timePerPixel * (slideWidth + slideMargin);

		return adjustedSpeed * 1000;
	};

	new Swiper('.highlights-slider', {
		speed: 1,
		loop: true,
		autoplay: {
			delay: 0,
			pauseOnMouseEnter: true,
			disableOnInteraction: false,
		},
		slidesPerView: 'auto',
		allowTouchMove: false,
		on: {
			beforeInit: (swiper) => {
				if (
					swiper.$el[0].querySelectorAll('.swiper-slide')
						.length === 0
					|| window.innerWidth < 768
				) {
					return;
				}

				while (getTotalWidth(swiper) < window.innerWidth) {
					swiper.$el[0]
						.querySelectorAll('.swiper-slide')
						.forEach(function (element) {
							const clone = element.cloneNode(true);
							swiper.$el[0]
								.querySelectorAll('.swiper-wrapper')[0]
								.appendChild(clone);
						});
				}
			},
			slideChangeTransitionEnd: (swiper) => {
				swiper.slideNext(getAdjustedSpeed(swiper));
			},
		},
	});
});

 /* add classes to Main Menu */
 $('#menu-main-menu').addClass(
	'display-flex justify__space-between align-center'
);
$('.mobile-menu .menu-main-menu-container').addClass('container');

/* page-narrow template - wrap everything that isn't a block in container */
 $(".page-alt .content")
   .children(":not('.block')")
   .wrap(
	   '<div class="container-xs" style="padding: 20px 15px;"></div>'
 );

 var addClassToPage = function() {
	if($('body').find(".all-posts.block")){
		$('body').addClass('all-posts-page');
	}
};
addClassToPage();

 $('body').css('visibility', 'visible');

 /* button click events */
 $("#menu-item-20").click(function() {
	var text = $(this).find('a');
	$(this).css('background', 'linear-gradient(90deg, #FF4578 6.01%, #FFA815 93.06%)');
	$(text).css('color', 'black');
 });

 $("#menu-item-16").click(function() {
	var text = $(this).find('a');
	$(this).css('background', 'linear-gradient(90deg, #FF4578 6.01%, #FFA815 93.06%)');
	$(this).css('border', 'none');
	$(text).css('color', 'black');
 });

 $("#menu-main-menu-1 .menu-item-20").click(function() {
	var text = $(this).find('a');
	$(this).css('background', 'linear-gradient(90deg, #FF4578 6.01%, #FFA815 93.06%)');
	$(text).css('color', 'black');
 });

 $("#menu-main-menu-1 .menu-item-16").click(function() {
	var text = $(this).find('a');
	$(this).css('background', 'linear-gradient(90deg, #FF4578 6.01%, #FFA815 93.06%)');
	$(this).css('border', 'none');
	$(text).css('color', 'black');
 });

 $(".btn").click(function() {
	var text = $(this).find('a');
	$(this).css('color', 'black');
	$(this).css('background', 'linear-gradient(90deg, #FF4578 6.01%, #FFA815 93.06%)');
	$(this).css('border', 'none');
	$(text).css('color', 'black');
 });

 $(".btn.cat-btn").click(function() {
	var text = $(this).find('a');
	$(this).css('color', '#82E9EC');
	$(this).css('background', 'transparent');
	$(this).css('border', '1px solid #82E9EC');
	$(text).css('color', '#82E9EC');
 });

 $("#gform_submit_button_1").click(function() {
	$(this).css('background', 'linear-gradient(90deg, #FF4578 6.01%, #FFA815 93.06%)');
	$(this).css('border', 'none');
	$(this).css('color', 'black');
 });

 $(".blue-cta").click(function() {
	var text = $(this).find('p');
	var path = $(this).find('path');
	$(text).css('background', 'linear-gradient(90deg, #FF4578 6.01%, #FFA815 93.06%)');
	$(text).css('-webkit-background-clip', 'text');
	$(text).css('-webkit-text-fill-color', 'transparent');
	$(path).css('stroke', '#ffb00a');
 });

 $(".dark-blue-cta").click(function() {
	var text = $(this).find('p');
	var path = $(this).find('path');
	$(text).css('background', 'linear-gradient(90deg, #FF4578 6.01%, #FFA815 93.06%)');
	$(text).css('-webkit-background-clip', 'text');
	$(text).css('-webkit-text-fill-color', 'transparent');
	$(path).css('stroke', '#ffb00a');
 });


 /* mobile menu - hamburger to cross functionality */
 $(".hamburger-to-cross").unbind('click').bind('click', function(e) {
	var mainNav = $(this).closest('nav').siblings(".menu-container");
	$(this).toggleClass('open');
	if (!$(mainNav).hasClass("open")) {
		$(mainNav).addClass("open");
		$(mainNav).slideDown(300);
	} else if ($(mainNav).hasClass("open")) {
		$(mainNav).removeClass("open");
		$(mainNav).slideUp(300);
	}
});

/* hero block - height */
var getHeroLeftHeight = function() {
	$('.fifty-fifty.short').each(function(){
		var left = $(this).find('.left');
		var bodyButtonWrapperHeight = $(this).find('.body-button-wrapper').height();
		$(left).css('min-height', bodyButtonWrapperHeight + 20);
	})
};
getHeroLeftHeight();

/* hero block - add slider if more than one Image Container exists */
if ($(".hero-with-slider .image-container").length > 1) {
	$(".hero-with-slider .image-container").addClass('swiper-slide');
	$(".hero-with-slider .image-container").wrapAll("<div class='hero-slider swiper'><div class='swiper-wrapper'></div></div>");
		var heroCarousel = new Swiper(".hero-slider", {
		loop: true,
		slidesPerView: 1,
		spaceBetween: 10,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false
		  },
		speed: 1500,
		navigation: {
			nextEl: ".hero-next",
			prevEl: ".hero-prev",
		},
	});
}

/* fifty-fifty block with tall image */
var addNegativeMarginToNextSibling = function() {
	$('.image-tall').each(function(){
		var block = $(this).closest('.block');
		$(block).next('.block').addClass('negative-margin');
	})
};
addNegativeMarginToNextSibling();

 /* add class to Main nav on scroll */
 $(window).scroll(function() {
	if ($(this).scrollTop() > 50) {
		$('.main-nav').addClass('scrolled');
	} else {
		$('.main-nav').removeClass('scrolled');
	}
});

/* accordion functionality */
$(".accordion-header").click(function() {
	$(this).parent().toggleClass("open");
	var content = $(this).siblings();
	$(content).slideToggle(300);
	var svg = $(this).find('svg');
	setTimeout(function() {
		if($(content).is(":hidden")){
			$(svg).css('transform', 'rotate(0deg)');
		}
	  }, 320);
});


/* 50/50 accordion with image */
$('.fifty-fifty-accordion-image .accordion:first-of-type').addClass('open');
$('.fifty-fifty-accordion-image .accordion:first-of-type .accordion-content').css('display', 'block');
$('.fifty-fifty-accordion-image .image-container:first-of-type').addClass('show');
var accordionWrapper = $('.fifty-fifty-accordion-image .accordion-wrapper');
var accordion = $(accordionWrapper).find('.accordion')
$(accordion).click(function() {
	var id = $(this).attr('id');
	$(this).addClass('open');
	var content = $(this).siblings().find('.accordion-content');
	$(content).css('display', 'none');
	$(this).siblings().removeClass('open');
	var imageContainer = $(this).closest('.accordion-cta').siblings().find('.image-container');
	$(imageContainer).each(function() {
		var imageId = $(this).attr('id')
		if (imageId == id) {
			$(this)
				.addClass('show');
				$(this)
				.siblings().removeClass('show');
		}
	})
})

/* single-team split h3 text */
const splitText = document.getElementsByClassName(
	'split-text'
   ).length > 0;
if(splitText){
	const ParagraphHTML = $('.split-text').text();
	const arr = ParagraphHTML.split(",");
	let secondPart = arr[0].split(' ').splice(-1).join(' ').trim();
	const firstPart = arr[0].replace(secondPart, '').trim();
	const thirdPart = arr.slice(1).join(",").trim();
	if(thirdPart != '') secondPart += ',';
	const ResultString = `${firstPart} <span style="font-weight: 700;">${secondPart}</span> ${thirdPart}`;
	$('.split-text').html(ResultString);
}

/* card carousel slider */
var cardCarousel = new Swiper(".card-carousel-slider", {
	loop: false,
	slidesPerView: 'auto',
	autoHeight: false,
	centeredSlides: false,
	observer: true,
	slidesOffsetAfter: 80,
	grabCursor: true,
	spaceBetween: 40,
	navigation: {
		nextEl: ".card-carousel-next",
		prevEl: ".card-carousel-prev",
	},
});
var card = $('<div class="card swiper-slide extra" style="border:none;"></div><div class="card swiper-slide extra" style="border:none;"></div>');
$('.card-carousel .swiper-wrapper').append(card);


/* gravity form */
$(".gform_wrapper select").addClass("dropdown");
$(".dropdown").select2();

var contactForm = $('#gform_wrapper_1');
$(contactForm).appendTo('.contact-form .right');

/* gravity form - wrap every 2 half width items in a wrapper */
var elems = $(".gfield--width-half");
wrapper = $('<div class="display-flex justify__space-between" />');
for (var i = 0;i < elems.length;i+=2){
    elems.filter(':eq('+i+'),:eq('+(i+1)+')').wrapAll(wrapper);
};

/* find grants block - grants dropdown  */
$(".dropdown-menu.grants").select2();
$('.dropdown-menu.grants').on('select2:select', function (e) {
	var dataName = $(this).find('option:selected').attr('data-name');
	var gridWrap = $(this).closest('.wrapper').siblings('.grid-wrap');
	var card = gridWrap.find('.card');

	if (dataName == "all-grants") {
		$(card).removeClass('hideCard');
		$(card).addClass('showCard');
		$('.empty-message').addClass('hide').removeClass('show');
		return;
	}

	$(card).each(function () {
		if ($(this).hasClass(dataName)) {
			$(this).addClass('showCard').removeClass('hideCard');
		} else {
			$(this).removeClass('showCard').addClass('hideCard');
		}
	});

	var elementsHavingTestClass = $(card).filter('.hideCard');
	if ($(elementsHavingTestClass).length == $(card).length) {
		$('.empty-message').removeClass('hide').addClass('show');
	} else {
		$('.empty-message').addClass('hide').removeClass('show');
	}
});

/* all posts block - category dropdown */
$(".dropdown-menu:not(.grants)").select2();
$(".dropdown-menu-audience").select2();
$('.dropdown-menu:not(.grants)').on('select2:select', function (e) {
	var dataName = $(this).find('option:selected').attr('data-name');
	var dataNameForAudience = $('.dropdown-menu-audience').find('option:selected').attr('data-name');
	var gridWrap = $(this).closest('.wrapper').siblings('.grid-wrap');
	var card = gridWrap.find('.card');
	$(card).each(function(){
		if($(this).hasClass(dataName) || $(this).hasClass(dataNameForAudience)){
			$(this).addClass('showCard');
			$(this).removeClass('hideCard');
		} else {
			$(this).removeClass('showCard');
			$(this).addClass('hideCard');
		}
		var elementsHavingTestClass = $(card).filter('.hideCard');
		if($(elementsHavingTestClass).length == $(card).length){
			$('.empty-message').removeClass('hide');
			$('.empty-message').addClass('show');
		}else{
			$('.empty-message').addClass('hide');
			$('.empty-message').removeClass('show');
		} if(dataName == "all-categories" && dataNameForAudience == "all-audiences"){
			$(card).each(function(){
				$(this).removeClass('hideCard');
				$(this).addClass('showCard');
				$('.empty-message').addClass('hide');
			$('.empty-message').removeClass('show');
			});
		}
	})
});

/* all posts block - audience dropdown */
$('.dropdown-menu-audience').on('select2:select', function (e) {
	var dataNameForAudience = $(this).find('option:selected').attr('data-name');
	var dataName = $('.dropdown-menu:not(.grants)').find('option:selected').attr('data-name');
	var gridWrap = $(this).closest('.wrapper').siblings('.grid-wrap');
	var card = gridWrap.find('.card');
	$(card).each(function(){
		if($(this).hasClass(dataName) || $(this).hasClass(dataNameForAudience)){
			$(this).addClass('showCard');
			$(this).removeClass('hideCard');
		} else {
			$(this).removeClass('showCard');
			$(this).addClass('hideCard');
		}
	})
	var elementsHavingTestClass = $(card).filter('.hideCard');
		if($(elementsHavingTestClass).length == $(card).length){
			$('.empty-message').removeClass('hide');
			$('.empty-message').addClass('show');
		}else{
			$('.empty-message').removeClass('show');
			$('.empty-message').addClass('hide');
		}if(dataName == "all-categories" && dataNameForAudience == "all-audiences"){
			$(card).each(function(){
				$(this).removeClass('hideCard');
				$(this).addClass('showCard');
				$('.empty-message').addClass('hide');
			$('.empty-message').removeClass('show');
			});
		}
});

/* download buttons - add icons */
$('.btn').each(function(){
	var btn = $(this)
	var buttonText = $(this).text();
	if (buttonText.toLowerCase().indexOf("(ios)") >= 0){
		var ios = $("<svg width='18' height='18' style='margin-left: 8px;' class='download' viewBox='0 0 27 33' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M25.5178 11.1538C25.3754 11.2429 21.986 13.124 21.986 17.2947C22.1458 22.0512 26.2632 23.7193 26.3339 23.7193C26.2632 23.8084 25.7122 25.9916 24.0801 28.2801C22.7847 30.2515 21.347 32.239 19.1638 32.239C17.0871 32.239 16.3417 30.9252 13.9455 30.9252C11.3722 30.9252 10.6441 32.239 8.6739 32.239C6.49071 32.239 4.9465 30.145 3.58057 28.1921C1.806 25.6362 0.297684 21.6252 0.244436 17.774C0.208551 15.7332 0.599811 13.7271 1.59301 12.0231C2.99483 9.64432 5.49751 8.0295 8.23054 7.97625C10.3246 7.90564 12.1883 9.41396 13.4663 9.41396C14.691 9.41396 16.9807 7.97625 19.5713 7.97625C20.6895 7.97741 23.6714 8.31426 25.5178 11.1538ZM13.2891 7.56879C12.9164 5.70509 13.9455 3.84139 14.904 2.65257C16.1287 1.21486 18.063 0.239021 19.7311 0.239021C19.8375 2.10272 19.1627 3.93053 17.9565 5.26174C16.8742 6.69945 15.0105 7.78178 13.2891 7.56879Z' fill='black'/></svg>");
		$(ios).appendTo(btn);
	}
	else if (buttonText.toLowerCase().indexOf("(android)") >= 0){
		var android = $("<svg width='18' height='18' style='margin-left: 8px;' class='download' viewBox='0 0 26 30' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.95467 0.371716C6.85332 0.374046 6.75452 0.403911 6.66885 0.45811C6.58318 0.512309 6.51387 0.5888 6.46835 0.679383C6.42284 0.769966 6.40283 0.871228 6.41047 0.972315C6.41812 1.0734 6.45312 1.1705 6.51174 1.25321L8.16346 3.64024C6.57756 4.85557 5.46679 6.66101 5.16986 8.73285H20.631C20.334 6.66101 19.2233 4.85557 17.6374 3.64024L19.2891 1.25321C19.3485 1.1693 19.3837 1.0706 19.3906 0.967996C19.3975 0.865393 19.376 0.762868 19.3284 0.671715C19.2808 0.580561 19.2089 0.504318 19.1208 0.451385C19.0326 0.398452 18.9315 0.370883 18.8287 0.371716C18.7381 0.372551 18.649 0.395434 18.5691 0.438389C18.4893 0.481345 18.4211 0.543083 18.3705 0.618274L16.7057 3.02712C15.5796 2.3961 14.2843 2.02998 12.9004 2.02998C11.5165 2.02998 10.2212 2.3961 9.09514 3.02712L7.43033 0.618274C7.37806 0.540612 7.3071 0.477333 7.22399 0.434251C7.14087 0.391169 7.04827 0.369665 6.95467 0.371716ZM9.54898 4.26427C10.1656 4.26427 10.6661 4.76475 10.6661 5.38142C10.6661 5.99808 10.1656 6.49856 9.54898 6.49856C8.93232 6.49856 8.43183 5.99808 8.43183 5.38142C8.43183 4.76475 8.93232 4.26427 9.54898 4.26427ZM16.2519 4.26427C16.8685 4.26427 17.369 4.76475 17.369 5.38142C17.369 5.99808 16.8685 6.49856 16.2519 6.49856C15.6352 6.49856 15.1347 5.99808 15.1347 5.38142C15.1347 4.76475 15.6352 4.26427 16.2519 4.26427ZM1.72896 10.9671C1.1123 10.9671 0.611816 11.4676 0.611816 12.0843V21.0215C0.611816 21.6381 1.1123 22.1386 1.72896 22.1386C2.34563 22.1386 2.84611 21.6381 2.84611 21.0215V12.0843C2.84611 11.4676 2.34563 10.9671 1.72896 10.9671ZM5.0804 10.9671V22.1386C5.0804 23.373 6.08024 24.3729 7.31469 24.3729V28.2829C7.31469 29.2079 8.06541 29.9586 8.99041 29.9586C9.9154 29.9586 10.6661 29.2079 10.6661 28.2829V24.3729H15.1347V28.2829C15.1347 29.2079 15.8854 29.9586 16.8104 29.9586C17.7354 29.9586 18.4861 29.2079 18.4861 28.2829V24.3729C19.7206 24.3729 20.7204 23.373 20.7204 22.1386V10.9671H5.0804ZM24.0719 10.9671C23.4552 10.9671 22.9547 11.4676 22.9547 12.0843V21.0215C22.9547 21.6381 23.4552 22.1386 24.0719 22.1386C24.6885 22.1386 25.189 21.6381 25.189 21.0215V12.0843C25.189 11.4676 24.6885 10.9671 24.0719 10.9671Z' fill='black'/></svg>");
		$(android).appendTo(btn);
	}
})

 /* single-post template - wrap everything that isn't a block in container */
 $(".single-post .wrap-content")
 .children(":not('.block')")
 .wrap(
	 '<div class="container-xs"></div>'
);

/* single post - insert blocks after content */
$('.container-xs.content .block').each(function(){
	$(this).insertAfter('.container-xs.content');
})

 /* add nav arrow to select bar */
 var navArrow =
 '<svg class="nav-arrow" width="15" height="14" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.05713 0.501709L5.40381 4.8479L9.75 0.501709" stroke="white"/></svg>';
 var navArrowDark =
 '<svg class="nav-arrow" width="15" height="14" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.05713 0.501709L5.40381 4.8479L9.75 0.501709" stroke="black"/></svg>';
$(navArrow).appendTo(".select2-selection__arrow");
$(navArrowDark).appendTo(".all-posts-dropdown .select2-selection__arrow");

 /* functions to be ran on resize */
$(window).resize(function() {
	getHeroLeftHeight();
});

/* animations */
$.fn.shouldAnimate = function() {
	var win = $(window);
	var topOffset = win.innerHeight() / 16;
	var viewport = {
		top: win.scrollTop() - 10,
		left: win.scrollLeft(),
	};
	viewport.right = viewport.left + win.width();
	viewport.bottom = viewport.top + win.height();
	var bounds = this.offset();
	bounds.right = bounds.left + this.outerWidth();
	bounds.bottom = bounds.top + this.outerHeight();
	return !(
		(
			viewport.right < bounds.left ||
			viewport.left > bounds.right ||
			viewport.bottom < bounds.top
		)
	);
};

function runAnimations() {
	$.each(
		$("[data-animation]:not(.animated),.animate:not(.animated)"),
		function(index, element) {
			if ($(this).shouldAnimate()) {
				$(this).addClass("animated");
				if ($(this).data("animation")) {
					$(this).addClass($(this).data("animation"));
				} else {
					let element = $(this);
					$.each($(this).attr("class").split(/\s+/), function(index, value) {
						if (value.indexOf("animate-") == 0) {
							element.addClass(value.substring(8));
						}
					});
				}
			}
		}
	);
}
runAnimations();

$(document).on("scroll", function() {
	runAnimations();
});


});

// Charger Map
function init_charger_map(){
	var $ = jQuery;

	if (window.location.search.indexOf('city=') > -1) {
		$('html,body').animate(
			{
				scrollTop: $('.charger-map').first().offset().top - 99,
			},
			500
		);
	}


	$('.charger-map-grid-map-container .map').each(function () {
		let coordinates;

		function initMap($el) {
			const map = new google.maps.Map($el[0], {
				disableDefaultUI: true,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				markers: [],
				/*styles: [
					{
						featureType: 'administrative',
						elementType: 'labels.text.fill',
						stylers: [
							{
								color: '#444444',
							},
						],
					},
					{
						featureType: 'landscape',
						elementType: 'all',
						stylers: [
							{
								color: '#f2f2f2',
							},
						],
					},
					{
						featureType: 'poi',
						elementType: 'all',
						stylers: [
							{
								visibility: 'off',
							},
						],
					},
					{
						featureType: 'road',
						elementType: 'all',
						stylers: [
							{
								saturation: -100,
							},
							{
								lightness: 45,
							},
						],
					},
					{
						featureType: 'road.highway',
						elementType: 'all',
						stylers: [
							{
								visibility: 'simplified',
							},
						],
					},
					{
						featureType: 'road.highway',
						elementType: 'geometry.fill',
						stylers: [
							{
								color: '#ffffff',
							},
						],
					},
					{
						featureType: 'road.arterial',
						elementType: 'labels.icon',
						stylers: [
							{
								visibility: 'off',
							},
						],
					},
					{
						featureType: 'transit',
						elementType: 'all',
						stylers: [
							{
								visibility: 'off',
							},
						],
					},
					{
						featureType: 'water',
						elementType: 'all',
						stylers: [
							{
								color: '#cce2e2',
							},
							{
								visibility: 'on',
							},
						],
					},
				],*/
			});

			return map;
		}

		function centerMap(map) {
			const bounds = new google.maps.LatLngBounds();
			map.markers.forEach((marker) => {
				bounds.extend({
					lat: marker.position.lat(),
					lng: marker.position.lng(),
				});
			});

			if (map.markers.length === 1) {
				map.setZoom(16);
				map.setCenter(bounds.getCenter());
			} else {
				map.fitBounds(bounds);
			}
		}

		function updateUserCoordinates(map, data, callback) {
			if (
				typeof coordinates !== 'undefined' &&
				data.city === coordinates.city &&
				data.location === coordinates.location
			) {
				return callback(map, data);
			}

			if (data.city === '' && data.location === '') {
				coordinates = undefined;
				return callback(map, data);
			}

			const geocoder = new google.maps.Geocoder();

			geocoder
				.geocode({
					address: data.city + ' ' + data.location,
					region: data.region,
				})
				.then((response) => {
					if (response.results[0]) {
						coordinates = {
							city: data.city,
							location: data.location,
							latitude:
								response.results[0].geometry.location.lat(),
							longitude:
								response.results[0].geometry.location.lng(),
						};
					}
					return callback(map, data);
				})
				.catch(() => {
					coordinates = undefined;
					return callback(map, data);
				});
		}

		function calculateDistance(lat1, lon1, lat2, lon2) {
			const radlat1 = (Math.PI * lat1) / 180;
			const radlat2 = (Math.PI * lat2) / 180;
			const theta = lon1 - lon2;
			const radtheta = (Math.PI * theta) / 180;
			let dist =
				Math.sin(radlat1) * Math.sin(radlat2) +
				Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
			dist = Math.acos(dist);
			dist = (dist * 180) / Math.PI;
			dist = dist * 60 * 1.1515 * 1.609344;
			return dist;
		}

		function sortResultsByDistance(results) {
			for (let i = 0; i < results.length; i++) {
				if (typeof coordinates !== 'undefined') {
					results[i].rawDistance = calculateDistance(
						coordinates.latitude,
						coordinates.longitude,
						results[i].location.lat,
						results[i].location.lng
					);
					results[i].distance =
						Math.round(results[i].rawDistance * 10) / 10 + 'km';
				} else {
					results[i].rawDistance = '';
					results[i].distance = '';
				}
			}

			results.sort((a, b) => {
				return a.rawDistance - b.rawDistance;
			});

			return results;
		}

		function addMarkersToMap(map, results) {
			while (map.markers.length) {
				map.markers.pop().setMap(null);
			}

			results.forEach((result, index) => {
				map.markers.push(
					new google.maps.Marker({
						position: {
							lat: parseFloat(result.location.lat),
							lng: parseFloat(result.location.lng),
						},
						map,
						title: result.title,
						label: {
							text: (index + 1).toString(),
							className: 'map-marker-label',
						},
					})
				);
			});

			centerMap(map);
		}

		function addMarkersToList(list, map, results) {
			const userLocation = $(list)
				.closest('.charger-map-grid')
				.find('.charger-map-grid-search-form [name="city"]')
				.val();

			results.forEach((result, index) => {
				results[index].typedLocation = userLocation;
			});

			list.html('');

			const template = list
				.siblings('.charger-map-grid-results-template')
				.html();

			results.forEach((result, index) => {
				result.index = index;
				list.append(replaceTemplateVariables(template, result));
			});

			map.markers.forEach((marker, index) => {
				marker.addListener('click', () => {
					const item = list.find('[data-index="' + index + '"]');

					if (item.length) {
						const scrollPosition =
							item.offset().top -
							list.offset().top +
							list.scrollTop();
						list.animate(
							{
								scrollTop: scrollPosition,
							},
							500
						);
					}
				});
			});

			list[0].querySelectorAll('.charger-map-grid-results-inner-item').forEach((item, index) => {
				item.addEventListener('mouseover', () => {
					map.markers[index].setAnimation(google.maps.Animation.BOUNCE);
					document.querySelectorAll('.map-marker-label').forEach((marker) => {
						if(marker.textContent == index + 1){
							marker.classList.add('marker-bouncing');
						}
					});
				});
				item.addEventListener('mouseout', () => {
					map.markers[index].setAnimation(null);
					document.querySelectorAll('.map-marker-label').forEach((marker) => {
						if(marker.textContent == index + 1){
							marker.classList.remove('marker-bouncing');
						}
					});
				});
			});

			if (results.length === 0) {
				const emptyResultsString = $(list).data('empty');

				list.append('<p>' + emptyResultsString + '</p>');
			}
		}

		function replaceTemplateVariables(template, data) {
			return template.replace(/%(\w*)%/g, (m, key) => {
				return data.hasOwnProperty(key) ? data[key] : '';
			});
		}

		function refreshMap(map, data = {}) {
			data.action = 'get_chargers';
			data.nonce = theme.nonce;
			$.ajax({
				type: 'post',
				dataType: 'json',
				url: theme.ajax_url,
				data,
				success: (response) => {
					const results = sortResultsByDistance(response.data);
					addMarkersToMap(map, results);
					const list = $(map.getDiv())
						.closest('.charger-map')
						.find('.charger-map-grid-results-inner');
					addMarkersToList(list, map, results);
				},
			});
		}

		const blockMap = initMap($(this));

		$(this)
			.closest('.charger-map')
			.find('.charger-map-grid-search-form')
			.on('change', function () {
				const data = new FormData(this);
				const values = Object.fromEntries(data.entries());
				updateUserCoordinates(blockMap, values, refreshMap);
			});

		$(this)
			.closest('.charger-map')
			.find('.charger-map-grid-search-form')
			.on('submit', function (e) {
				e.preventDefault();
			});

		$(this)
			.closest('.charger-map')
			.find('.charger-map-grid-search-form')
			.trigger('change');
	});
}

window.init_charger_map = init_charger_map;
